import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
export default class AnalyticsUsageTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'analytics (usage)';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.ANALYTICS.USAGE, ($e, data) => {
            this.trackButtonEventSegment(data);
        });
    }
}
